export default __webpack_public_path__ + "static/media/other5.e2bd6903.jpg";